import React from 'react';
import { FiX, FiCheck, FiAlertTriangle, FiInfo } from 'react-icons/fi';

interface AcceptApplicationModalProps {
  applicantName: string;
  onConfirm: () => void;
  onCancel: () => void;
}

export const AcceptApplicationModal: React.FC<AcceptApplicationModalProps> = ({
  applicantName,
  onConfirm,
  onCancel,
}) => {
  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/70 backdrop-blur-sm">
      <div
        className="w-full max-w-[440px] bg-[#0c0c0c] border border-white/10 rounded-[28px] overflow-hidden shadow-2xl"
        style={{ animation: 'fadeInScale 0.2s ease-out' }}
      >
        {/* Header */}
        <div className="flex items-center justify-between px-6 pt-6">
          <h3 className="text-white text-[17px] font-semibold">Accept this applicant?</h3>
          <button
            onClick={onCancel}
            className="p-1.5 text-zinc-500 hover:text-white transition-colors rounded-full hover:bg-white/5"
          >
            <FiX size={20} />
          </button>
        </div>

        {/* Body */}
        <div className="flex flex-col items-center px-6 pt-8 pb-6">
          {/* Warning icon */}
          <div className="w-16 h-16 rounded-full bg-amber-900/40 flex items-center justify-center mb-6">
            <FiAlertTriangle size={28} className="text-amber-400" />
          </div>

          <p className="text-white text-[18px] font-semibold text-center mb-6 leading-relaxed">
            Are you sure you want to accept this application?
          </p>
          <p className="text-zinc-400 text-sm text-center mb-6">{applicantName}</p>

          {/* Info banner */}
          <div className="w-full flex items-start gap-3 px-4 py-3.5 rounded-2xl border border-amber-500/30 bg-amber-900/15 mb-6">
            <FiInfo size={18} className="text-amber-400 shrink-0 mt-0.5" />
            <p className="text-amber-400/90 text-[13px] leading-relaxed">
              Next, you'll create an offer. The applicant is notified when you send it.
            </p>
          </div>
        </div>

        {/* Actions */}
        <div className="flex gap-3 px-6 pb-6">
          <button
            onClick={onCancel}
            className="flex-1 h-12 rounded-full border border-white/15 text-white text-[15px] font-semibold hover:bg-white/5 transition-all active:scale-[0.97]"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            className="flex-1 h-12 rounded-full bg-white text-black text-[15px] font-semibold hover:bg-zinc-200 transition-all active:scale-[0.97] flex items-center justify-center gap-2"
          >
            <FiCheck size={16} className="text-green-600" />
            Accept & Create Offer
          </button>
        </div>
      </div>

      <style>{`
        @keyframes fadeInScale {
          from { opacity: 0; transform: scale(0.95); }
          to { opacity: 1; transform: scale(1); }
        }
      `}</style>
    </div>
  );
};
